export default{
    preferredBase:{
        Notification:{
           
        },
        Message:{
            
        },
        Alert:{
            error:{
                title:'提示',
                text:'数据请求失败，请重试',
                buttonText:'确定',
            }
        },
        Button:{
            
        },
        Placeholder:{

        },
        Validate:{

        },
        Description:{
            banner:{
                text1:'品质的源头',
                text2:'始于优质的产地',
    
            },
            module1:{
                item:{
                    text1:'作物',
                    text2:'面积',
                    text3:'亩',
                    text4:'年产量',
                    text5:'公斤',
                    text6:'年产值',
                    text7:'万元',
                }
            },
            module2:{
                tabs:['基地介绍','基地产品','基地视频','基地监测'],
                more:'查看更多',
            },
        },
        Checkbox:{
            
        },
        Table:{

        },
        ValidData:{
            
        },
        InvalidData:{
            
        },
        Confirm:{
           
        },
        Dialog:{
            title:'图片'
        }
    }
    
}